import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './Cart.css';
import { useCart } from '../context/CartContext';
import { useSettings } from '../context/SettingsContext';

function Cart() {
  const { cartItems, removeFromCart, clearCart } = useCart();
  const { currencySymbol } = useSettings();
  const navigate = useNavigate();

  // Calculate total
  const calculateTotal = () => {
    return cartItems.reduce((total, item) => total + (item.price * item.quantity), 0).toLocaleString('en-IN');
  };

  // Handle proceed to checkout
  const handleCheckout = () => {
    navigate('/checkout');
  };

  return (
    <div className="cart-page">
      <h1>Your Cart</h1>

      {cartItems.length === 0 ? (
        <div className="empty-cart">
          <p>Your cart is empty.</p>
          <Link to="/" className="continue-shopping">Continue Shopping</Link>
        </div>
      ) : (
        <div className="cart-content">
          <table className="cart-table">
            <thead>
              <tr>
                <th>Service</th>
                <th>Price ({currencySymbol})</th>
                <th>Quantity</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {cartItems.map(item => (
                <tr key={item.id}>
                  <td>{item.name}</td>
                  <td>{item.price}</td>
                  <td>{item.quantity}</td>
                  <td>
                    <button 
                      onClick={() => removeFromCart(item.id)} 
                      className="remove-button"
                    >
                      Remove
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr>
                <td colSpan="1" className="total-label">Total:</td>
                <td className="total-amount">{currencySymbol}{calculateTotal()}</td>
                <td colSpan="2"></td>
              </tr>
            </tfoot>
          </table>

          <div className="cart-actions">
            <button onClick={clearCart} className="clear-cart">Clear Cart</button>
            <button onClick={handleCheckout} className="checkout-button">Proceed to Checkout</button>
          </div>
        </div>
      )}
    </div>
  );
}

export default Cart; 